export function extractCountry(city) {
  try {
    return city.match(/.*,(.*)/)[1];
  } catch (error) {
    console.error(error);
    return '';
  }
}
